export default __webpack_public_path__ + "static/media/gomaids-logo.67fa7e64.png";